import React from "react";
import Card from "../Card";
import Text from "../Text";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      flexDirection: "column",
    },
  })
);

function StepContainer({ children, title }) {
  const classes = useStyles();
  return (
    <Card heading={<Text color="textPrimary">{title}</Text>}>
      <div className={classes.container}>{children}</div>
    </Card>
  );
}

export default StepContainer;
